import { DatePicker } from 'antd';
import dayjs from 'libs/dayjs';

const { RangePicker } = DatePicker;

// Presets de rango usados en todos los listados. Mismo criterio que el
// RangePicker de TecnicosPage, pero pensado para filtros opcionales (sin
// rango por defecto): el usuario lo aplica cuando lo necesita.
const PRESETS = [
  { label: 'Este mes', value: () => [dayjs().startOf('month'), dayjs()] },
  { label: 'Últimos 3 meses', value: () => [dayjs().subtract(3, 'month'), dayjs()] },
  { label: 'Este año', value: () => [dayjs().startOf('year'), dayjs()] },
];

/**
 * Filtro de rango de fechas reutilizable. Controlado.
 *
 * @param {object} props
 * @param {[import('dayjs').Dayjs, import('dayjs').Dayjs] | null} props.value
 *   Par de fechas seleccionado (o null si vacío).
 * @param {(from: string|null, to: string|null) => void} props.onChange
 *   Recibe las fechas como strings `YYYY-MM-DD` (o null al limpiar).
 * @param {number} [props.width=260]
 */
export default function DateRangeFilter({ value, onChange, width = 260 }) {
  return (
    <RangePicker
      value={value}
      presets={PRESETS.map((p) => ({ label: p.label, value: p.value() }))}
      onChange={(range) =>
        onChange(
          range?.[0] ? range[0].format('YYYY-MM-DD') : null,
          range?.[1] ? range[1].format('YYYY-MM-DD') : null
        )
      }
      allowClear
      format="DD/MM/YYYY"
      placeholder={['Desde', 'Hasta']}
      style={{ width }}
    />
  );
}
